import axios from "axios";
import { BASE_URL } from ".";

export interface CreateTicketRequest {
  first_name: string;
  last_name: string;
  contact_email: string;
  question_type: string;
  information: string;
}

export interface CreateTicketResponse {
  success: boolean;
  ticket_number?: string;
  contact_email?: string;
  message: string;
  errors?: {
    [key: string]: string[];
  };
  error?: string;
}

export class SupportService {
  public static async createTicket(ticketData: CreateTicketRequest): Promise<CreateTicketResponse> {
    try {
      const response = await axios.post(
        `${BASE_URL}/edit-api/tickets/create/`,
        ticketData,
        {
          headers: {
            'Content-Type': 'application/json',
            // 如果需要认证，可以添加Authorization header
            // 'Authorization': `Bearer ${getAccessToken()}`
          }
        }
      );
      
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // 返回服务器的错误响应
        return error.response.data;
      }
      
      // 网络错误或其他错误
      throw new Error('Network error occurred while creating ticket');
    }
  }
}